import { apiSlice } from "../api/apiSlice";

export const videosApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getVideos: builder.query({
			query: () => "videos",
		}),
		addVideo: builder.mutation({
			query: ({ data }) => ({
				url: "/videos",
				method: "POST",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const video = await queryFulfilled;
					if (video?.data?.id) {
						// update tasks cache pessimistically start
						dispatch(
							apiSlice.util.updateQueryData(
								"getVideos",
								undefined,
								(draft) => {
									// console.log(JSON.parse(JSON.stringify(draft)));
									draft.push(video.data)
								}
							)
						);
						// update tasks cache pessimistically end
					}
				} catch (err) { }
			},
		}),
		editVideo: builder.mutation({
			query: ({ id, data }) => ({
				url: `/videos/${id}`,
				method: "PATCH",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// optimistic cache update start
				const pathResult = dispatch(
					apiSlice.util.updateQueryData(
						"getVideos",
						undefined,
						(draft) => {
							const draftVideo = draft.find((video) => video.id == arg.id);
							draftVideo.title = arg.data.title;
							draftVideo.description = arg.data.description;
							draftVideo.url = arg.data.url;
							draftVideo.views = arg.data.views;
							draftVideo.duration = arg.data.duration;
							draftVideo.createdAt = arg.data.createdAt;
						}
					)
				);
				// optimistic cache update end

				try {
					await queryFulfilled;
				} catch (err) {
					pathResult.undo();
				}
			},
		}),
		deleteVideo: builder.mutation({
			query: ({ id }) => ({
				url: `/videos/${id}`,
				method: "DELETE",
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// optimistic cache update start
				const result = dispatch(
					apiSlice.util.updateQueryData(
						"getVideos",
						undefined,
						(draft) => {
							return draft.filter((video) => video.id != arg.id);
						}
					)
				);
				// optimistic cache update end
				try {
					await queryFulfilled;
				} catch (err) {
					result.undo();
				}
			},
		}),
	}),
});

export const {
	useGetVideosQuery,
	useAddVideoMutation,
	useEditVideoMutation,
	useDeleteVideoMutation
} = videosApi;
